// extracted by mini-css-extract-plugin
export var dropdownButton = "_44-0";
export var fullWidthDropdownButton = "_44-1";
export var icon = "_44-3";
export var iconPlaceholder = "_44-2";
export var menuItemRow = "_44-8";
export var separator = "_44-c";
export var shortcutContainer = "_44-7";
export var shortcutIconLg = "_44-6";
export var shortcutIconMd = "_44-5";
export var shortcutIconSm = "_44-4";
export var submenuChevron = "_44-b";
export var submenuDropdown = "_44-9";
export var submenuTriggerRow = "_44-a";